import { useState, FormEvent } from 'react';

export type BindCheckbox = {
  checked: boolean;
  onChange: (event: FormEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
};

export const useCheckbox = (
  initialValue: boolean,
  field: string,
  onChangeHook?: (field: string, value: boolean) => void,
) => {
  const [value, setValue] = useState(initialValue);

  return {
    value,
    setValue,
    reset: () => setValue(false),
    bind: {
      checked: value,
      onChange: (event: FormEvent<HTMLInputElement>) => {
        const isChecked = event.currentTarget.checked;
        setValue(isChecked);
        if (onChangeHook) {
          onChangeHook(field, isChecked);
        }
      },
    },
  };
};
